import {Stack} from "@mui/material";
import {CustomSkeleton} from "../../../components/CustomSkeleton/CustomSkeleton";

export function SidebarLoading() {
    return <>
        <Stack sx={{height: 34, width: 108, pl: '4px'}} direction="row"
               alignItems={'center'}
               className='goldern-record-cluster-type-button-group'>
            {/* <CustomSkeleton width={134} height={30}/> */}
            <CustomSkeleton width={124} height={28}/>
        </Stack>

        <CustomSkeleton sx={{marginTop: '8px'}} width={232} height={40}/>
        <CustomSkeleton sx={{marginTop: '24px'}} width={232} height={20}/>
        <Stack gap={'4px'} sx={{marginTop: '12px'}}>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
            <CustomSkeleton width={232} height={50}/>
        </Stack>
    </>
}